module.exports = __webpack_public_path__ + "img/4064019960.07d5cb42.jpg";